
angular.module('cesium.es.plugin', [
    // Services
    'cesium.es.services',
    // Controllers
    'cesium.es.app.controllers',
    'cesium.es.common.controllers',
    'cesium.es.settings.controllers',
    'cesium.es.currency.controllers',
    'cesium.es.wot.controllers',
    'cesium.es.wallet.controllers',
    'cesium.es.profile.controllers',
    'cesium.es.message.controllers',
    'cesium.es.notification.controllers',
    'cesium.es.blockchain.controllers',
    'cesium.es.network.controllers',
    'cesium.es.registry.controllers',
    'cesium.es.group.controllers',
    'cesium.es.invitation.controllers',
    'cesium.es.subscription.controllers',
    'cesium.es.document.controllers',
    'cesium.es.like.controllers',
    'cesium.es.admin.controllers'
  ])
;
